<template>
  <div>
    <navbar :is-spaced="false" />
    <nuxt-child :site-name="name" />
    <section v-if="$route.path === '/'" class="section is-small">
      <div class="container">
        <loan-application />
      </div>
    </section>
    <lazy-hydrate ssr-only>
      <footer-comp logo="false" />
    </lazy-hydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'

export default {
  layout: 'whitelabel',
  components: {
    LazyHydrate,
    footerComp: () => import( '~/whitelabels/components/footer' ),
    loanApplication: () => import( '~/components/loanApplication' ),
    navbar: () => import( '~/whitelabels/components/navbar' )
  },
  head () {
    const desc = 'Lainojen yhdistäminen - Yhdistelylaina - Yhdistä lainat - Lainaa 70 000 € - Yhdistä lainat yhdeksi yhdistelylaina'
    const theme = '#e78200'
    return {
      title: `${this.name} | Lainahakemus`,
      meta: [
        { hid: 'description', name: 'description', content: desc },
        { hid: 'og:title', name: 'og:title', property: 'og:title', content: this.name },
        { hid: 'og:site_name', name: 'og:site_name', property: 'og:site_name', content: this.name },
        { hid: 'og:description', name: 'og:description', property: 'og:description', content: desc },
        { hid: 'apple-mobile-web-app-title', name: 'apple-mobile-web-app-title', content: this.name },
        { hid: 'theme-color', name: 'theme-color', content: theme }
      ],
      link: [{ rel: 'icon', type: 'image/x-icon', href: require( '~/assets/whitelabels/finloan/favicon.png' ) }]
    }
  },
  data () {
    return {
      name: 'Finloan',
      domain: 'finloan.fi'
    }
  }
}
</script>

<style lang="scss">
@import "~assets/whitelabels/scss/_variables.scss";

$wl-primary: #e78200;
$wl-body-background: url('~assets/whitelabels/finloan/bg.jpg');

$wl-navbar-background: #fff;
$wl-navbar-height: 7.5rem;
$wl-navbar-logo-height: 4.75rem;

$wl-slider-handle-border: 2px solid white;

$wl-footer-color: white;
$wl-footer-background: #0e1015;

@import "~assets/whitelabels/scss/styles.scss";

.whitelabel.finloan {
  @include whitelabel;
}
</style>
